import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { COMMON_IMPORTS } from '@easihub/ngx';
import { faArrowRight, faBook, faBriefcase, faBuilding, faComments, faCompass, faCrown, faCube, faEnvelope, faHandshake, faHeadset, faInfoCircle, faLifeRing, faList, faNewspaper, faPenToSquare, faPhone, faRocket, faShield, faStar, faTrophy, faUsers, faUserTie, faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';
import { ContactLinks } from '../contact';

@Component({
  selector: 'footer#app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
  imports: [
    COMMON_IMPORTS,
    RouterModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'role': 'contentinfo',
  }

})
export class AppFooterComponent {
  protected readonly icons = {
    faUsers,
    faArrowRight,
    faCube,
    faBuilding,
    faBook,
    faHeadset
  } as const;

  protected readonly currentYear = new Date().getFullYear();

  protected readonly communityLinks = [
    {
      text: 'Explore',
      link: 'https://easihub.com/community/categories',
      icon: faRocket,
      primary: true
    },
    {
      text: 'Discussions',
      link: 'https://easihub.com/community/latest',
      icon: faComments
    },
    {
      text: 'Experts',
      // TODO: update to correct URL when community experts page is available
      link: 'https://easihub.com/community/get-started',
      icon: faCrown
    },
    {
      text: 'Stories',
      // TODO: update to correct URL when community success stories page is available
      link: 'https://easihub.com/community/get-started',
      icon: faTrophy
    }
  ];

  protected readonly socialLinks = [
    ContactLinks.linkedin,
    ContactLinks.twitter,
    ContactLinks.github,
    ContactLinks.email
  ];

  protected readonly platformLinks = [
    {
      text: 'Join Community',
      link: '/community',
      icon: faUsers,
      primary: true
    },
    {
      text: 'Browse Experts',
      link: '/experts',
      icon: faUserTie
    },
    {
      text: 'Success Stories',
      link: '/stories',
      icon: faTrophy
    },
    {
      text: 'Become Expert',
      link: '/experts/become',
      icon: faStar
    },
    {
      text: 'EASiHub Talent',
      link: '/talent',
      icon: faBriefcase,
      primary: true
    },
    {
      text: 'Platform Features',
      link: '/features',
      icon: faWandMagicSparkles
    }
  ];

  protected readonly companyLinks = [
    {
      text: 'About EASiHub',
      link: '/about',
      icon: faInfoCircle
    },
    {
      text: 'Careers',
      link: '/careers',
      icon: faHandshake
    },
    {
      text: 'Press Kit',
      link: '/press',
      icon: faNewspaper
    },
    {
      text: 'Contact',
      link: '/contact-us',
      icon: faEnvelope
    }
  ];

  protected readonly resourcesLinks = [
    {
      text: 'Help Center',
      link: '/help',
      icon: faLifeRing
    },
    {
      text: 'Blog',
      link: '/blog',
      icon: faNewspaper
    },
    {
      text: 'Community Guidelines',
      link: '/community/guidelines',
      icon: faList
    },
    {
      text: 'Posting Guidelines',
      link: '/community/posting-guidelines',
      icon: faPenToSquare
    },
    {
      text: 'Code of Conduct',
      link: '/community/code-of-conduct',
      icon: faShield
    },
    {
      text: 'Start Exploring',
      link: '/community',
      icon: faCompass
    }
  ];

  protected readonly contactItems = [
    {
      href: 'mailto:hello@easihub.com',
      icon: faEnvelope,
      text: 'hello@easihub.com'
    },
    {
      href: 'tel:+1-800-EASIHUB',
      icon: faPhone,
      text: '+1-800-EASIHUB'
    },
    {
      href: '/chat',
      icon: faComments,
      text: 'Live Chat'
    }
  ];

  protected readonly socialPlatforms = [
    ContactLinks.linkedin,
    ContactLinks.twitter,
    ContactLinks.discord,
    ContactLinks.github
  ];
}
